import React, { Suspense, useEffect, useState } from "react";
import Header from "./../../CommonComponents/Header";
import HeaderBackground from "./../../CommonComponents/HeaderBackground";
import NotificationCards from "./NotificationCards";
import { useHistory } from "react-router";

import { HomePageServices } from "../../../../../_services/Arya2.0/HomePageServices";
import { eventTracker } from "../../GATracker3.0/eventTracker";
import {
  NOTIFICATION_CLICKED,
  addInfoNotificationValue,
} from "../../GATracker3.0/constants";
const Registration = React.lazy(() =>
  import("../../Registration/Registration")
);

// const data = [
//   {
//     name: "Today",
//     notifications: [
//       {
//         label: "37 New Quotes on Ambemohor Rice 50 MT - Guru Warehouse",
//         onClick: null,
//       },
//       {
//         label: "37 New Quotes on Ambemohor Rice 50 MT - Guru Warehouse",
//         onClick: null,
//       },
//       {
//         label: "37 New Quotes on Ambemohor Rice 50 MT - Guru Warehouse",
//         onClick: null,
//       },
//     ],
//   },
//   {
//     name: "This Week",
//     notifications: [
//       {
//         label: "37 New Quotes on Ambemohor Rice 50 MT - Guru Warehouse",
//         onClick: null,
//       },
//       {
//         label: "37 New Quotes on Ambemohor Rice 50 MT - Guru Warehouse",
//         onClick: null,
//       },
//       {
//         label: "37 New Quotes on Ambemohor Rice 50 MT - Guru Warehouse",
//         onClick: null,
//       },
//     ],
//   },
// ];

const Notification = ({ setShow = () => { }, notifications = [], handleEmailVerifyPopUp }) => {
  const [data, setData] = useState([]);
  const [regShow, setRegShow] = useState(false);

  const history = useHistory();

  useEffect(() => {
    modifyData(notifications);
  }, [notifications]);

  const modifyData = (dataArray) => {
    let newArray = [];

    dataArray.forEach((obj) => {
      let newObj = {
        title: obj.title,
        body: obj.body,
        finance:
          obj.type === "LOAN_DISBURSEMENT" || obj.type === "RELEASE_STOCK"
            ? true
            : false,
        onClick: () => {
          eventTracker("event", NOTIFICATION_CLICKED, {
            pagename: "notification",
            addinfo: addInfoNotificationValue[obj.type],
          });
          getNotificationData(obj);
          redirectUrl(obj);
        },
      };
      newArray.push(newObj);
    });
    setData(newArray);
  };
  const redirectUrl = (dataObj) => {
    if (dataObj.type === "LOAN_DISBURSEMENT") {
      history.push("/disbursement/" + dataObj?.reference_data?.sr_id);
    } else if (dataObj.type === "RELEASE_STOCK") {
      history.push(
        "/arya2/release-stock/" +
        dataObj?.reference_data?.warehouse_code +
        "/" +
        dataObj?.reference_data?.commodity_id +
        "/" +
        dataObj?.reference_data?.contract_id
      );
    } else if (dataObj.type === "LEAD_QUOTATION") {
      history.push("/buyer-requirements/" + dataObj?.reference_data?.unique_id);
    } else if (dataObj.type === "SPOT_CONTRACT_CREATION") {
      history.push("/view-contract/" + dataObj?.reference_data?.contract_id);
    } else if (dataObj.type === "COMMODITY_INWARD") {
      history.push("/token-details/" + dataObj?.reference_data?.token_hash);
    } else if (dataObj.type === "EMAIL_VERIFICATION") {
      handleEmailVerifyPopUp();
    } else {
      setRegShow(true);
    }
  };

  const getNotificationData = async (data) => {
    let obj = { id: data.id };
    await HomePageServices.getUserReadNotification(obj);
  };
  return (
    <div
      className={`stdFontStyle font-size16 letterSpacing015  line-height19 OverThePageCSS`}
    >
      {regShow && (
        <Suspense fallback={<></>}>
          <Registration show={regShow} setShow={setRegShow} />
        </Suspense>
      )}
      <HeaderBackground>
        <Header
          title="Notifications"
          // secondaryIcon={settingIcon}
          onSecondaryIconClick={() => null}
          onBackArrowClick={() => setShow(false)}
        />
      </HeaderBackground>
      <NotificationCards data={data} />
    </div>
  );
};

export default Notification;
